<!-- Header bar -->
<et-pdf-viewer-header
  class="shrink-0"
  [file]="file"
  [totalPages]="totalPages()"
  [page]="page()"
  (showOverlay)="showOverlay.set($event)"
  (changePage)="page.set($event)"
></et-pdf-viewer-header>

<!-- PDF viewer  -->
<div class="flex-1 min-h-0 overflow-hidden">
  <et-pdf-viewer-page
    [file]="file"
    [showOverlay]="showOverlay()"
    [page]="page()"
    [maxHeight]="maxPageHeight"
    (adjustPage)="page.set($event)"
  ></et-pdf-viewer-page>
</div>
